module.exports = __webpack_public_path__ + "img/structure_image.32b66c9a.png";